export interface DailyPost {
  id: string;
  title: string;
  category: string;
  date: string;
  excerpt: string;
  tags: string[];
  cover: string;
}

export const dailyPosts: DailyPost[] = [
  {
    id: "daily-01",
    title: "抢灵果现场：大师姐一出手，全峰鸦雀无声",
    category: "师姐互动",
    date: "08-15",
    excerpt: "云隐峰后山的百年灵果熟了，师弟师妹们摩拳擦掌。结果苏师姐剑未出鞘，一个眼神就让所有人乖乖列队。",
    tags: ["苏挽月", "师门日常", "名场面"],
    cover:
      "https://readdy.ai/api/search-image?query=Group%20of%20young%20cultivators%20sneaking%20to%20pick%20glowing%20spirit%20fruit%20in%20a%20moonlit%20mountain%20orchard%2C%20Chinese%20ink%20wash%20illustration%2C%20playful%20heist%20atmosphere%2C%20warm%20gold%20lanterns%2C%20refined%20detail&width=900&height=620&seq=daily-fruit-01&orientation=landscape",
  },
  {
    id: "daily-02",
    title: "炼丹房的灾难现场：二师兄又双叒炸炉了",
    category: "师兄关系",
    date: "08-12",
    excerpt: "沈无咎信誓旦旦这一炉稳了，三息之后药香混着焦味扑面而来。大师兄默默递上一本新的《炼丹入门》。",
    tags: ["沈无咎", "炼丹", "搞笑日常"],
    cover:
      "https://readdy.ai/api/search-image?query=Chaotic%20alchemy%20room%20with%20a%20small%20explosion%20of%20smoke%20and%20glowing%20embers%2C%20flustered%20young%20cultivator%2C%20Chinese%20ink%20wash%20illustration%2C%20humorous%20warm%20tones%2C%20refined%20detail&width=900&height=620&seq=daily-furnace-01&orientation=landscape",
  },
  {
    id: "daily-03",
    title: "小师弟偷跑下山，全峰上演「寻人启事」",
    category: "同门情谊",
    date: "08-08",
    excerpt: "温如初一时兴起溜去山脚集市，结果惊动半座山峰。大师兄找到他时，只说了句「下次带上我」。",
    tags: ["温如初", "同门情谊", "日常"],
    cover:
      "https://readdy.ai/api/search-image?query=Busy%20mountain%20town%20market%20at%20dusk%20with%20paper%20lanterns%2C%20a%20young%20disciple%20wandering%20happily%20among%20stalls%2C%20Chinese%20ink%20wash%20illustration%2C%20warm%20festive%20tones%2C%20refined%20detail&width=900&height=620&seq=daily-missing-01&orientation=landscape",
  },
  {
    id: "daily-04",
    title: "夜谈听雨：三师姐难得开口讲了十个字",
    category: "师姐互动",
    date: "08-02",
    excerpt: "雨夜围炉，向来寡言的林霜迟难得说了句完整的话：「若有人欺你们，喊我。」全峰感动三秒。",
    tags: ["林霜迟", "护短", "夜谈"],
    cover:
      "https://readdy.ai/api/search-image?query=Disciples%20gathered%20by%20a%20warm%20brazier%20listening%20to%20rain%20on%20a%20quiet%20rainy%20night%2C%20cozy%20sect%20hall%2C%20Chinese%20ink%20wash%20illustration%2C%20soft%20teal%20and%20gold%20tones%2C%20refined%20detail&width=900&height=620&seq=daily-rain-01&orientation=landscape",
  },
  {
    id: "daily-05",
    title: "师尊的「慈祥」抽查：作业没写完的都罚抄",
    category: "师门日常",
    date: "07-28",
    excerpt: "玄真子笑眯眯地走进演武场，一句「抽查心法」让全峰弟子集体石化。大师兄默默把罚抄名额背了下来。",
    tags: ["玄真子", "罚抄", "师徒"],
    cover:
      "https://readdy.ai/api/search-image?query=Elderly%20sect%20master%20reviewing%20young%20disciples%20in%20a%20wide%20training%20ground%2C%20disciples%20looking%20nervous%2C%20Chinese%20ink%20wash%20illustration%2C%20morning%20light%2C%20warm%20tones%2C%20refined%20detail&width=900&height=620&seq=daily-check-01&orientation=landscape",
  },
  {
    id: "daily-06",
    title: "云渺的擦肩：一句话让全站开始疯狂考据",
    category: "暗线纠葛",
    date: "07-20",
    excerpt: "外门师妹云渺路过演武场时留下的半句话，被读者截图分析了一整天，暗线讨论热度直线飙升。",
    tags: ["云渺", "暗线", "考据"],
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20young%20woman%20in%20lavender%20hanfu%20walking%20through%20misty%20sect%20gate%2C%20ambiguous%20silhouette%2C%20Chinese%20ink%20wash%20illustration%2C%20cool%20ethereal%20tones%2C%20refined%20detail&width=900&height=620&seq=daily-cloud-01&orientation=landscape",
  },
];